import React, { useMemo, useState } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import IrrView from './IrrView'
import RevenueLeasing from './RevenueLeasing'
import Insurance from './Insurance'
import Cam from './Cam'
import OperatingCosts from './OperatingCosts'
import IRRViewNew from './IRRViewNew'
import RevenueLeasingNew from "./RevenueLeasingNew"
import RevenueLeasingNew1 from "./RevenueLeasingNew1"
import RevenueLeasingNew2 from "./RevenueLeasingNew2"
import InsuranceNew from "./InsuranceNew"
import CamNew from "./CamNew"
import OperatingCostsNew from "./OperatingCostsNew"
import Construction from "./Construction"
import { useGetPortfolioSummaryQuery } from 'store/slices/apis/portfolioSummarySlice'
import { useGetAllProjectsQuery } from 'store/slices/apis/projectApiSlice'
import CustomSelect from './CustomSelect'

const irrData = {
    underwritingCost: 327,
    actualCost: 360,
    projectIRR: 11.24,
    equityIRR: 13.3
};

const revenueData = {
    areaUnderwriting: 109227,
    areaActual: 109227,

    lcdUnderwriting: "25 Apr 27",
    lcdActual: "25 Apr 27",
    rcdUnderwriting: "25 Apr 27",
    rcdActual: "25 Apr 27",

    leaseUnderwriting: 180,
    leaseActual: 180,

    camUnderwriting: "1 Cr",
    camActual: "1 Cr",

    rentUnderwriting: 3,
    rentActual: 3,
    rentalComparisionUnderwriting: 19,
    rentalComparisionActual: 19,
};


const insuranceData = {
    active: 12,
    inactive: 18,
    total: 3,
    cost: 53,
    expiring: 6
};

const camData = {
    revenue: 6,
    cost: 6,
    margin: 0,
    marginPercent: 0
};

const operationCostData = {
    budget: 6,
    actual: 6,
    difference: 0
};

export const assetOptions = [
    { value: "WH1", label: "WH1" },
    { value: "WH2", label: "WH2" },
    { value: "WH3", label: "WH3" },
];

export const componentOptions = [
    { value: "component", label: "Component" },
];

export const insuranceTypeOptions = [
    { value: "CAR", label: "CAR" },
    { value: "FLOP", label: "FLOP" },
];

export const policyStatusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
];

export const providerOptions = [
    { value: "13.3%", label: "13.3%" },
];

export const statusOptions = [
    { value: "Construction yet to start", label: "Construction yet to start" },
    { value: "Under construction", label: "Under construction" },
    { value: "Leased, construction yet to commence", label: "Leased, construction yet to commence" },
    { value: "Leased, construction yet to start", label: "Leased, construction yet to start" },
    { value: "Leased, underconstruction", label: "Leased, underconstruction" },
    { value: "Leased, handed over", label: "Leased, handed over" },
    { value: "Vacant", label: "Vacant" },
];

export const tenantOptions = [
    { value: "DHL", label: "DHL" },
    { value: "NA", label: "NA" },
    { value: "Safex", label: "Safex" },
];

export const escalationOptions = [
    { value: "5% pa", label: "5% pa" },
    { value: "15% every 3 years", label: "15% every 3 years" },
];


const AssetManagement = () => {
    const [projectType, setProjectType] = useState(localStorage.getItem("projectType") || "all")
    const { data: projectRes } = useGetAllProjectsQuery(projectType);
    const { data: portfolioRes } = useGetPortfolioSummaryQuery();

    const [filters, setFilters] = useState({
        ProjectType: "all",
        ProjectId: null,
    });

    const portfolioOptions = useMemo(() => {
        const apiOptions = (portfolioRes?.data || []).map((p) => ({
            value: p.portFolioType,
            label: p.portfolioName,
        }));

        return [
            { value: "all", label: "All Portfolio" },
            ...apiOptions,
        ];
    }, [portfolioRes]);

    const projectOptions = useMemo(() => {
        const projectData = projectRes?.data || [];

        return projectData
            .filter((p) => p.active)
            .map((p) => ({
                value: p.projectId,
                label: p.projectName,
            }));
    }, [projectRes]);

    const selectedPortfolio = useMemo(() => {
        return (
            portfolioOptions.find(
                (opt) => opt.value === filters.ProjectType
            ) || null
        );
    }, [portfolioOptions, filters.ProjectType]);

    const selectedProject = useMemo(() => {
        return (
            projectOptions.find(
                (opt) => opt.value === filters.ProjectId
            ) || null
        );
    }, [projectOptions, filters.ProjectId]);

    const handlePortfolioChange = (option) => {
        const projectType = option?.value || "all";

        setProjectType(projectType);

        setFilters({
            ProjectType: projectType,
            ProjectId: null,
        });
    };

    const handleProjectChange = (option) => {
        const projectId = option?.value || null;

        setFilters((prev) => ({
            ...prev,
            ProjectId: projectId,
        }));
    };


    const handleChange = (item) => {
        console.log("item", item)
    }


    return (
        <>
            <Grid container sx={{ p: 0, pb: 6 }}>
                <Grid size={12} sx={{ bgcolor: "#F6F8F9", p: 2, pt: 2 }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: { xs: "column", md: "row" },
                                gap: 1,
                            }}
                        >
                            <Typography
                                variant="h5" sx={{ fontSize: '36px', fontWeight: 700, color: '#252525', lineHeight: "48px", letterSpacing: '-0.4px' }}
                            >
                                Asset Management Dashboard
                            </Typography>
                        </Box>
                        <Typography
                            sx={{
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "100%",
                                letterSpacing: "0px",
                                fontFamily: "Outfit, sans-serif",
                                mt: "6px"
                            }}
                        >
                            Real-time IRR, leasing, development, insurance alerts & opex tracking for optimized portfolio decisions.
                        </Typography>
                    </Box>
                    <Grid size={12}>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                            <Grid size={2}>

                                <CustomSelect
                                    name="portfolio"
                                    options={portfolioOptions}
                                    value={filters.ProjectType}
                                    onChange={(e) => handlePortfolioChange(e.option)}
                                    placeholder="Select Portfolio"
                                />
                            </Grid>
                            <Grid size={2}>

                                <CustomSelect
                                    name="project"
                                    options={projectOptions}
                                    value={filters.ProjectId}
                                    onChange={(e) => handleProjectChange(e.option)}
                                    placeholder="Select Project"
                                />
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
                <Grid size={12} spacing={2.5} container sx={{ bgcolor: "#fff", p: 2, pt: 2 }}>
                    <Grid size={12} spacing={2} >
                        {/* <IrrView data={irrData} /> */}
                        <IRRViewNew />
                    </Grid>
                    <Grid size={12}>
                        {/* <RevenueLeasing data={revenueData} /> */}
                        <RevenueLeasingNew />
                    </Grid>
                    <Grid size={12}>
                        <RevenueLeasingNew1 />
                    </Grid>
                    <Grid size={12}>
                        <RevenueLeasingNew2 />
                    </Grid>
                    <Grid size={12}>
                        {filters?.ProjectId && <Construction projectId={filters.ProjectId} />}
                    </Grid>
                    <Grid size={12}>
                        <InsuranceNew />
                    </Grid>
                    <Grid size={12}>
                        <CamNew />
                    </Grid>
                    <Grid size={12}>
                        <OperatingCostsNew />
                    </Grid>
                    {/* <Grid size={12}>
                        <Insurance data={insuranceData} />
                    </Grid>
                    <Grid size={12}>
                        <Cam data={camData} />
                    </Grid>
                    <Grid size={12}>
                        <OperatingCosts data={operationCostData} />
                    </Grid> */}
                </Grid>
            </Grid>
        </>
    )
}

export default AssetManagement
